var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconProposals = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.644 9.794-4.769 4.768-2.344.47L8 12.687l4.769-4.77a1.32 1.32 0 0 1 1.87 0l.005.006a1.32 1.32 0 0 1 0 1.87M2.844 4.719h6.562M2.844 7.531h6.562M2.844 10.344h3.281M5.188 13.156H1.906a.94.94 0 0 1-.937-.937V1.906A.937.937 0 0 1 1.906.97H8.55c.249 0 .487.098.663.274l1.795 1.795a.94.94 0 0 1 .274.663v1.955"
  }))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.644 9.794-4.769 4.768-2.344.47L8 12.687l4.769-4.77a1.32 1.32 0 0 1 1.87 0l.005.006a1.32 1.32 0 0 1 0 1.87M2.844 4.719h6.562M2.844 7.531h6.562M2.844 10.344h3.281M5.188 13.156H1.906a.94.94 0 0 1-.937-.937V1.906A.937.937 0 0 1 1.906.97H8.55c.249 0 .487.098.663.274l1.795 1.795a.94.94 0 0 1 .274.663v1.955"
  }))));
});
export default SvgIconProposals;
export const raw = __webpack_public_path__ + "static/media/IconProposals.7cf1f09d02dba4c2ef88b11b3fd7260e.svg";